var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "transfer" },
    [
      _c("popup", {
        staticClass: "popup",
        attrs: { opened: _vm.openData, "use-header": true, "use-footer": true },
        on: {
          "update:opened": function($event) {
            _vm.openData = $event
          },
          cancel: _vm.popupClose
        },
        scopedSlots: _vm._u([
          {
            key: "subtitle",
            fn: function() {
              return [
                _c("h2", [
                  _vm._v(
                    _vm._s(/*이체 확인증 (타행)*/ _vm.$t("MPAY-04-01-07-01"))
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "content",
            fn: function() {
              return [
                _c("div", { staticClass: "divider" }, [
                  _c("span", { staticClass: "divider-date" }, [
                    _vm._v(
                      _vm._s(/*신청 일시*/ _vm.$t("MPAY-04-01-07-02")) +
                        " : " +
                        _vm._s(
                          _vm.$getGlobalDateFmt(
                            _vm._.padEnd(_vm.detailInfo.tranTimeCCT, 20, " ")
                          )
                        )
                    )
                  ])
                ]),
                _c("div", { staticClass: "cont-tit" }, [
                  _c("h6", [
                    _vm._v(_vm._s(/*출금정보*/ _vm.$t("MPAY-04-01-07-03")))
                  ])
                ]),
                _c("dl", { staticClass: "dlist dlist-item--type6" }, [
                  _c("dt", [
                    _vm._v(_vm._s(/*은행명*/ _vm.$t("MPAY-04-01-07-09")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.detailInfo.rmtancBrnNameCCT))
                  ]),
                  _c("dt", [
                    _vm._v(_vm._s(/*출금 계좌번호*/ _vm.$t("MPAY-04-01-07-04")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.detailInfo.rmtancAcitmNoCCT))
                  ]),
                  _c("dt", [
                    _vm._v(_vm._s(/*예금주명*/ _vm.$t("MLON-01-01-11-05")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.detailInfo.rmtrNameCCT))
                  ]),
                  _c("dt", [
                    _vm._v(_vm._s(/*출금 금액*/ _vm.$t("MPAY-04-01-07-05")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _c("span", { staticClass: "exchange-unit" }, [
                      _vm._v("MMK")
                    ]),
                    _c("span", { staticClass: "amount" }, [
                      _vm._v(_vm._s(_vm.$num(_vm.detailInfo.tranAmtCCT)))
                    ])
                  ]),
                  _c("dt", [
                    _vm._v(_vm._s(/*수수료*/ _vm.$t("MPAY-04-01-07-06")))
                  ]),
                  _c("dd", { staticClass: "right" }, [
                    _c("span", { staticClass: "exchange-unit" }, [
                      _vm._v("MMK")
                    ]),
                    _c("span", { staticClass: "amount" }, [
                      _vm._v(_vm._s(_vm.$num(_vm.detailInfo.aplyFeeAmtCCT)))
                    ])
                  ]),
                  _c("dt", [
                    _vm._v(_vm._s(/*송금목적*/ _vm.$t("PCOP-02-03-05-24")))
                  ]),
                  _vm.detailInfo.rmtancInfoCtntCCT.includes(":") &&
                  /^[A-Z0-9]{1}[0-9]{1}$/.test(
                    _vm.detailInfo.rmtancInfoCtntCCT.split(":", 1)
                  )
                    ? _c("dd", { staticClass: "right" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                _vm.detailInfo.rmtancInfoCtntCCT.split(":", 1) +
                                  "_송금목적구분_MMR2"
                              ) /* 송금목적구분_MMR2: 타행이체신청내역조회(_MMR: 인뱅기준/_MMR2: 단말기준) */
                            ) +
                            " "
                        )
                      ])
                    : _c("dd", { staticClass: "right" }, [
                        _vm._v(_vm._s(_vm.detailInfo.rmtancInfoCtntCCT))
                      ])
                ]),
                _c("div", { staticClass: "cont-tit" }, [
                  _c("h6", [
                    _vm._v(_vm._s(/*입금 정보*/ _vm.$t("MPAY-04-01-07-08")))
                  ])
                ]),
                _c(
                  "dl",
                  { staticClass: "dlist dlist-item--type6" },
                  [
                    _vm.siteCode != _vm.$config.SITECODE_OGAUC
                      ? [
                          _c("dt", [
                            _vm._v(
                              _vm._s(/* 은행명 */ _vm.$t("MPAY-04-01-07-09"))
                            )
                          ]),
                          _c("dd", { staticClass: "right" }, [
                            _vm._v(_vm._s(_vm.detailInfo.rcevnBnkNameCCT))
                          ])
                        ]
                      : _vm._e(),
                    _vm.siteCode == _vm.$config.SITECODE_OGMMR
                      ? [
                          _c("dt", [
                            _vm._v(
                              _vm._s(/* 입금 지점 */ _vm.$t("MPAY-02-01-26-17"))
                            )
                          ]),
                          _c("dd", { staticClass: "right" }, [
                            _vm._v(_vm._s(_vm.detailInfo.rcevnBrnNameCCT))
                          ])
                        ]
                      : _vm._e(),
                    _c("dt", [
                      _vm._v(
                        _vm._s(/*입금 계좌번호*/ _vm.$t("MPAY-04-01-07-10"))
                      )
                    ]),
                    _c("dd", { staticClass: "right" }, [
                      _vm._v(_vm._s(_vm.detailInfo.draweAcitmNoCCT))
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*입금 금액*/ _vm.$t("MPAY-04-01-07-11")))
                    ]),
                    _c("dd", { staticClass: "right" }, [
                      _c("span", { staticClass: "exchange-unit" }, [
                        _vm._v("MMK")
                      ]),
                      _c("span", { staticClass: "amount" }, [
                        _vm._v(_vm._s(_vm.$num(_vm.detailInfo.tranAmtCCT)))
                      ])
                    ]),
                    _vm.siteCode == _vm.$config.SITECODE_OGMMR
                      ? [
                          _c("dt", [
                            _vm._v(
                              _vm._s(/*지점명*/ _vm.$t("MPRS-02-02-02-06"))
                            )
                          ]),
                          _c("dd", { staticClass: "right" }, [
                            _vm._v(_vm._s(_vm.detailInfo.rcevnBrnNameCCT))
                          ])
                        ]
                      : _vm._e(),
                    _c("dt", [
                      _vm._v(_vm._s(/*수취인*/ _vm.$t("MPAY-04-01-07-12")))
                    ]),
                    _c("dd", { staticClass: "right" }, [
                      _vm._v(_vm._s(_vm.detailInfo.draweNameCCT))
                    ]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(
                          /*Particulars*/ /*수취인 참조내용*/ _vm.siteCode ==
                            _vm.$config.SITECODE_OGAUC
                            ? _vm.$t("MPAY-02-01-12-22")
                            : _vm.$t("MPAY-04-01-06-A14")
                        )
                      )
                    ]),
                    _c("dd", { staticClass: "right" }, [
                      _vm._v(_vm._s(_vm.detailInfo.memoCCT))
                    ])
                  ],
                  2
                ),
                _c("ul", { staticClass: "ulist ulist-type--bullet" }, [
                  _c("li", [
                    _vm._v(
                      _vm._s(
                        /*위의 내용이 정상적으로 처리되었음을 확인합니다. */ _vm.$t(
                          "MPAY-04-01-10-18"
                        )
                      )
                    )
                  ]),
                  _c("li", [
                    _vm._v(
                      _vm._s(
                        /*이체확인증은 고객 편의를 위하여 제공되는 것으로 거래의 참고용으로만 사용될 수 있습니다.*/ _vm.$t(
                          "MPAY-04-01-10-19"
                        )
                      )
                    )
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "bank-name" },
                  [
                    _vm.siteCode == _vm.$config.SITECODE_OGHCM
                      ? [
                          _vm.operGroupCd == "VN1"
                            ? [
                                _vm._v(
                                  _vm._s(_vm.$t(_vm.siteCode + "_지점명칭"))
                                )
                              ]
                            : [_vm._v(_vm._s(_vm.$t("oghni_지점명칭")))]
                        ]
                      : [_vm._v(_vm._s(_vm.$t(_vm.siteCode + "_지점명칭")))]
                  ],
                  2
                )
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: {
                      click: function($event) {
                        return _vm.popupClose()
                      }
                    }
                  },
                  [_vm._v(_vm._s(/*확인*/ _vm.$t("MPAY-04-01-10-21")))]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }